// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  membershipId: __t.u64().primaryKey().name("membership_id"),
  orgId: __t.u64().name("org_id"),
  userIdentity: __t.identity().name("user_identity"),
  role: __t.string(),
  createdAt: __t.i64().name("created_at"),
});
